import { PaginationProps } from 'antd';
import { Icon } from 'ui';

const Previous = (props: any) => {
  return (
    <button {...props}>
      <Icon name={'pagination-prev'} type={'any'} />
    </button>
  );
};

const Next = (props: any) => {
  return (
    <button {...props}>
      <Icon name={'pagination-next'} type={'any'} />
    </button>
  );
};

export const paginationNavigationRenderer: PaginationProps['itemRender'] = (
  _,
  type,
  originalElement
) => {
  if (type === 'prev') {
    const prev = (originalElement as any)?.props;
    return <Previous {...prev} />;
  }
  if (type === 'next') {
    const next = (originalElement as any)?.props;
    return <Next {...next} />;
  }
  return originalElement;
};
